import { useState, useEffect, useRef } from 'react'
import { PubSub } from 'pubsub-js'
import qs from 'qs'

const WS_URL = `${process.env.REACT_APP_WEBSOCKET_URL}/api/zhikuan/mn/plate/edit`
const query = qs.parse(location.search, { ignoreQueryPrefix: true })
const timeout = 1000

export const SOCKET_STATUS = {
  HEART_BEAT: 1, // 心跳
  OPEN_SEND: 2, // 总体数据消息
  LOCATION_SEND: 3 // 用户编辑位置
}
export const useSocket = ({ permissions, accountInfo }) => {
  const [state, setState] = useState(false)
  const websocket = useRef()
  let currentTime
  let currentFocus = { requestBody: { focus: '-' }, requestType: SOCKET_STATUS.LOCATION_SEND }
  const createWebSocket = (url) => {
    websocket.current = new WebSocket(url)
    websocket.current.onopen = () => {
      heartCheck.init(url)
      heartCheck.reset().start(url)
    }
    websocket.current.onerror = (e) => {
      console.error(e)
      reconnect(url)
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    websocket.current.onclose = () => {
    }
    websocket.current.onmessage = (event) => {
      !state && setState(true)
      currentTime = Date.now()
      if (event.data) {
        const data = JSON.parse(event.data)
        PubSub.publish('message', data)
      }
    }
  }
  const reconnect = (url) => {
    createWebSocket(url)
  }
  const heartCheck = {
    timeout,
    timeoutObj: null,
    reset() {
      clearInterval(this.timeoutObj)
      return this
    },
    start(url) {
      this.timeoutObj = setInterval(() => {
      // onmessage拿到返回的心跳就说明连接正常
        socketSend({ requestType: SOCKET_STATUS.HEART_BEAT }, '', url)
      }, this.timeout)
    },
    init(url) {
      socketSend(currentFocus, '', url)
      socketSend({ requestType: SOCKET_STATUS.HEART_BEAT }, '', url)
    }
  }

  const socketSend = (data, key, url) => {
    if (!websocket.current) return
    if (key == 'focus') {
      currentFocus = data
    }
    // eslint-disable-next-line prefer-const
    let startTime = Date.now()
    if ((startTime - currentTime) >= timeout * 2) {
      setState(false)
      reconnect(url)
    }
    if (websocket.current.readyState == 1) {
      try {
        websocket.current.send(JSON.stringify(data))
      } catch (error) {
        console.error(error)
      }
    }
  }
  // 关闭连接
  const closeWebSocket = () => {
    websocket.current?.close()
  }
  useEffect(() => {
    if (!permissions || !('WebSocket' in window)) return
    try {
      createWebSocket(`${WS_URL}/${query.collectId}/${accountInfo.userId}`)
      return () => closeWebSocket()
    } catch (err) {
      console.error(err)
    }
  }, [permissions])
  return {
    state,
    socketSend
  }
}
